import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgApple = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.0066 7.66198C11.1306 7.66198 9.77463 6.66598 8.34663 6.70198C6.46263 6.72598 4.73463 7.79397 3.76263 9.48597C1.80663 12.882 3.25863 17.898 5.16663 20.658C6.10263 22.002 7.20663 23.514 8.67063 23.466C10.0746 23.406 10.6027 22.554 12.3067 22.554C13.9987 22.554 14.4787 23.466 15.9667 23.43C17.4787 23.406 18.4387 22.062 19.3626 20.706C20.4307 19.146 20.8746 17.634 20.8986 17.55C20.8626 17.538 17.9586 16.422 17.9226 13.062C17.8986 10.254 20.2147 8.90998 20.3227 8.84998C19.0027 6.91798 16.9747 6.70198 16.2667 6.65398C14.4186 6.50998 12.8707 7.66198 12.0066 7.66198ZM15.1266 4.82998C15.9066 3.89398 16.4227 2.58598 16.2787 1.28998C15.1627 1.33798 13.8187 2.03398 13.0147 2.96998C12.2947 3.79798 11.6706 5.12998 11.8386 6.40198C13.0746 6.49798 14.3467 5.76598 15.1266 4.82998Z",
		fill: "black"
	})
});
export default SvgApple;
